// extracted by mini-css-extract-plugin
export default {"root":"LoadProgress_root__MlzB4"};